<!-- by 7527189 2 0 -->
<template>
  <div>
    <div v-if="showAdd">
      <a-row :gutter="24" >
        <a-col :md="24">
          <a-card  :bordered="false">
            <a-form-model ref="form" :model="form" :rules="rules">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="被授权方ID" prop="licensee">
                <a-input :disabled="detail" placeholder="请输入被授权方ID(主账号)" v-model="form.licenseeNo" @change="searchName"/>
              </a-form-model-item>
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="被授权方名称">
                {{licenseeName}}
              </a-form-model-item>

              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="授权类型" prop="type">
                <a-select :disabled="detail" placeholder="选择授权类型" v-model="form.type">
                  <a-select-option :value="item.value" v-for="(item,index) in delimiter" >{{item.title}}</a-select-option>
                </a-select>
              </a-form-model-item>

              <a-form-model-item prop="chooseData" :labelCol="labelCol" :wrapperCol="{ xs: { span: 6 }, sm: { span: 18 }, }" label="授权内容">
                <a-button v-show="!detail" @click="chooseData" type="primary" style="margin-bottom: 10px">添加</a-button>
                <a-table ref="thetable" bordered :columns="columns" :dataSource="dataSource">
                  <span v-show='!detail' slot="action" slot-scope="text, record">
                    <a-popconfirm  title="确定删除吗?" @confirm="() => del(record)">
                      <a>删除</a>
                    </a-popconfirm>
                  </span>
                </a-table>
              </a-form-model-item>
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="授权有效期" prop="datestatus">
                <a-select :disabled="detail" placeholder="选择授权有效期" v-model="form.datestatus" @change="datestatusChange()">
                  <a-select-option value='3'>永久有效</a-select-option>
                  <a-select-option value="1">固定有效期</a-select-option>
                  <a-select-option value="2">自当日起x日</a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item v-if="form.datestatus == '1'" :labelCol="labelCol" prop="endTime" :wrapperCol="wrapperCol" label="截止日期">
                <j-date :disabled="detail" v-model="form.endTime" dateFormat="YYYY-MM-DD " placeholder="请输入日期" :show-time="true" />
              </a-form-model-item>

              <a-form-model-item v-if="form.datestatus == '2'" :labelCol="labelCol" prop="duration" :wrapperCol="wrapperCol" label="截止日期">
                <a-input :disabled="detail"  placeholder="请输入正整数" v-model="form.duration"/>
              </a-form-model-item>

              <a-form-model-item v-show="form.id" :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态" prop="status">
                <a-radio-group :disabled="detail"  v-model="form.status">
                  <a-radio value="0">停用</a-radio>
                  <a-radio value="1">启用</a-radio>
                </a-radio-group>
              </a-form-model-item>
              <a-form-model-item :disabled="detail" :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注" prop="remark">
                <a-textarea :disabled="detail" v-model="form.remark"></a-textarea>
              </a-form-model-item>
            </a-form-model>
            <div style="text-align: right">
              <a-button @click="showAdd=false">返回</a-button>
              <a-button v-show="!detail" @click="submit" type="primary" style="margin-left: 10px" >提交</a-button>
            </div>
          </a-card>
        </a-col>
      </a-row>
    </div>
    <a-row :gutter="24" v-else>
      <a-col :md="24">
        <a-card  :bordered="false">
          <a-radio-group v-model="mode" :style="{ marginBottom: '8px' }">
            <a-radio-button value="igiveyou">
              我的授权
            </a-radio-button>
            <a-radio-button value="yougiveme">
              我收到的授权
            </a-radio-button>
          </a-radio-group>
          <iGiveYou @add="addDataGive" @update="updateDataGive" ref="igiveyou" class="child" v-if="mode == 'igiveyou'"></iGiveYou>
          <youGiveMe @detail="showDetail" ref="yougiveme" class="child" v-else></youGiveMe>
        </a-card>
      </a-col>
    </a-row>
    <choose-data ref="cd" @ok="chooseOk"></choose-data>
  </div>
</template>
<script>

import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import iGiveYou from './iGiveYou.vue'
import youGiveMe from './youGiveMe.vue'
import ChooseData from '@views/dataGive/chooseData.vue'
import { getAuthorize, getTenant, insertAuthorize, updateAuthorize } from '@api/api'
import { queryEnableDictItemsByCode } from '@api/identifierCode/identifierCode'
import JDate from '@comp/jeecg/JDate.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'MaterialList',
  mixins: [JeecgListMixin],
  ...mapGetters(["nickname", "loginName", "info"]),
  components: {
    JDate,
    ChooseData,
    iGiveYou,
    youGiveMe
  },
  data () {
    return {
      detail:false,
      licenseeName:'',
      mode:'igiveyou',
      showAdd:false,
      delimiter:[],
      form: {
        licensee:'',
        status:'3',
        remark:'',
        datestatus:'',
        licenseeNo:''
      },
      columns:[],
      labelCol: {
        xs: { span: 6 },
        sm: { span: 2 },
      },
      wrapperCol: {
        xs: { span: 6 },
        sm: { span: 6 },
      },
      rules: {
        endTime: [{ required: true, message: '请输入结束时间' }],
        duration: [{ required: true, message: '请输入结束时间' }],
        licensee: [{ required: true, message: '请输入被授权方ID' }],
        type: [{ required: true, message: '请选择授权类型' }],
        status: [{ required: true, message: '请选择状态' }],
        datestatus: [{ required: true, message: '请选择状态' }],
        chooseData:[{ required: true,validator:(_,value)=>{
            if(this.dataSource.length == 0){
              return Promise.reject('请选择授权内容')
            }
            return Promise.resolve()
          }}]
      },
    }
  },
  created () {



    queryEnableDictItemsByCode({code: 'authorize_type'})
      .then(res => {
        this.delimiter = res

      })
  },
  computed: {

  },
  methods: {
    showDetail(row){
      this.updateDataGive(row,'detail')
    },
    del(item){
      this.dataSource.forEach((d,i)=>{
        if(item.id == d.id){
          this.dataSource.splice(i,1)
        }
      })
    },
    chooseOk(data,columns){
      let c = JSON.parse(JSON.stringify(columns))
      c.push({
        "title": '操作',
        scopedSlots: { customRender: 'action' },
      })
      this.columns = c
      this.dataSource = data
    },
    searchName(){
      let n = this.form.licenseeNo
      this.licenseeName = ''
      this.form.licensee = ''
      getTenant(n).then((res) => {
        if(res.result.tenantId == localStorage.userID && !this.detail){
          this.$message.warning('无法对自己进行授权')
        }else{
          this.licenseeName = res.result.username
          this.form.licensee = res.result.tenantId
        }
      })
    },
    submit(){
      this.$refs.form.validate(valid => {
        if(valid === true) {
          console.log('this.form=>', this.form)
          if (!this.form.licensee) {
            this.$message.warning('请输入正确的被授权方ID')
            return false
          }
          // <a-select-option value="3">永久有效</a-select-option>
          // <a-select-option value="1">固定有效期</a-select-option>
          // <a-select-option value="2">自当日起x日</a-select-option>
          if (this.form.datestatus == '1') {
            this.form.duration = null
          }
          if (this.form.datestatus == '2') {
            this.form.endTime = null
          }
          if (this.form.datestatus == '3') {
            this.form.duration = null
            this.form.endTime = null
          }
          this.form.ids = this.dataSource.map(d => d.specificationId + '')
          if (this.form.id) {
            updateAuthorize(this.form).then(res => {
              console.log(res)
              if( res.code == 200 && res.success == true ){
                this.$message.success(res.message)
                this.showAdd = false
                this.$refs.igiveyou.fatherMethod()
              } else {
                this.$message.error(res.message)
              }
              
            })
          } else {
            insertAuthorize(this.form).then(res => {
              console.log(res)
              if( res.code == 200 && res.success == true ){
                this.$message.success(res.message)
                this.showAdd = false
                this.$refs.igiveyou.fatherMethod()
              } else {
                this.$message.error(res.message)
              }
              
            })
          }

        }
      })
    },
    chooseData () {
      this.$refs.cd.show(this.form.type, this.dataSource)
    },
    addDataGive () {
      //初始化
      this.columns = []
      this.dataSource = []
      this.licenseeName = ''
      this.form = {
        licensee:'',
          status:'3',
          remark:'',
          datestatus:'',
          licenseeNo:''
      }
      this.$nextTick(()=>{
        this.showAdd = true
        this.form.type = this.delimiter[0].value
      })
    },
    updateDataGive(row,type){

      if(type=='detail'){
        this.detail = true
      }else{
        this.detail = false
      }
      console.log(type,this.detail)
      getAuthorize(row.id).then(res=>{
        console.log(res)
        let cols = []
        for (const k in res.result.titleMap) {
          cols.push({
            "title": res.result.titleMap[k],
            "dataIndex": k
          })
        }
        cols.push({
          "title": '操作',
          scopedSlots: { customRender: 'action' },
        })
        this.columns = cols
        this.dataSource = res.result.authorizeVos
        this.form = res.result
        if(res.result.duration != null){
          this.form.datestatus = '2'
        }else if(res.result.endTime == null){
          this.form.datestatus = '3'
        }else{
          this.form.datestatus = '1'
        }

        this.form = JSON.parse(JSON.stringify(this.form))

        this.searchName()
        this.$nextTick(()=>{
          this.showAdd = true
        })
      })
    }
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';

.elementButtonText {
  color: #409eff;
  cursor: pointer;
}

</style>
<style>
.child{
  margin-left: -36px !important;
  margin-right: -36px !important;
}
</style>